<!--
 * @Description:
 * @Author: wjx
 * @Github:
 * @LastEditors: Please set LastEditors
 * @Date: 2019-03-29 13:49:26
 * @LastEditTime: 2022-12-22 21:15:47
 -->
<template>
  <div>
    <el-menu
      :default-active="activeIndex"
      :unique-opened="true"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      @select="handSelect"
      :collapse="isCollapse"
    >
      <template v-for="(item, index) in asideList">
        <el-menu-item
          :index="item.index"
          v-if="!item.menus"
          style="padding-left:10px;"
          :route="item.menu_url"
          :key="index"
        >
          <!-- <i class="el-icon-menu" v-show="isCollapse"></i> -->
          <img
            :src="[index == activeIndex ? item.activeIcon : item.icon]"
            style="width:26px;height:26px;"
          />
          <span style="display: inline-block;text-align:left" slot="title">
            {{ item.name }}
          </span>
        </el-menu-item>
        <el-submenu
          v-else
          :index="item.index"
          popper-class="active-submenu"
          style="padding-left:10px;"
          :key="index"
        >
          <template slot="title" style="padding-left:0;">
            <i class="el-icon-menu" v-show="isCollapse"></i>
            <img :src="item.icon" style="width:26px;height:26px;" />
            <span
              style="width:70%; display: inline-block;text-align:left"
              slot="title"
            >
              {{ item.name }}
            </span>
          </template>
          <el-menu-item-group>
            <el-menu-item
              v-for="childrenItem in item.menus"
              :key="childrenItem.menu_name"
              :index="item.index"
              :route="childrenItem.menu_url"
            >
              <img
                :src="[
                  index == activeIndex
                    ? childrenItem.activeIcon
                    : childrenItem.icon
                ]"
                style="width:26px;height:26px;"
              />
              {{ childrenItem.menu_name }}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import { getStorage } from '@/tools/storage';
import {
  userGuide,
  userGuide2,
  zoneGuide,
  accountManagementGuide,
  digtalStorageGuide
} from '@/assets/staticData';
export default {
  name: '',
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeIndex: '0',
      userAuthData: {},
      change: false,
      asideList: userGuide2
    };
  },
  computed: {
    ...mapState({
      defaultAsideActive: state => state.aside.defaultAsideActive,
      menusList: state => state.aside.menusList,
      tabActive: state => state.aside.tabActive,
      userInfo: state => state.user.userInfo.user,
      userGuideArr: state => {
        const arr = [11, 12, 13, 14, 15];
        const projectType = state.homeProject.projectType;
        // return arr.includes(projectType) ? userGuide2 : userGuide
        return userGuide2;
      }
    }),
    ...mapGetters(['getMenusListRoles'])
  },
  methods: {
    ...mapMutations(['CHANGEASIDEACTIVE', 'SET_PAGENUM', 'SET_INIT']),
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handSelect(key, keyPath) {
      //点击侧边菜单
      this.activeIndex = '' + key;
      if (/zone|information/.test(this.$route.path)) {
        if (key == 0) {
          this.$router.push({
            path: '/zone/list'
          });
        } else {
          this.$router.push({
            path: '/information/list'
          });
        }
      } else if (/contract/.test(this.$route.path)) {
        if (key == 0) {
          this.$router.push({
            path: '/contract/list'
          });
        } else {
          this.$router.push({
            path: '/contract/list'
          });
        }
      } else if (/accountManagement/.test(this.$route.path)) {
        if (key == 0) {
          this.$router.push({
            path: '/accountManagement/subAccountManagement'
          });
        } else if (key == 1) {
          this.$router.push({
            path: '/accountManagement/operationLog'
          });
        } else {
          this.$router.push({
            path: '/accountManagement/mainAccountManagement'
          });
        }
      } else {
        if (key == 0) {
          this.$router.push({
            path: '/edit/index',
            query: {
              id: this.$route.query.id
            }
          });
        } else if (key == 1) {
          this.activeIndex = '' + key;
          this.$router.push({
            path: '/accept/index',
            query: {
              id: this.$route.query.id || this.$route.query.projectId
            }
          });
        } else if (key == 2) {
          this.activeIndex = '' + key;
          this.$router.push({
            name: 'v3-task-progress-list',
            query: {
              id: this.$route.query.id || this.$route.query.projectId
            }
          });
        }
      }
      // this.SET_INIT({})
      this.change = true;
      this.SET_PAGENUM(1);
      this.CHANGEASIDEACTIVE(key); // 改变对应aside
    }
  },
  watch: {
    $route(to) {
      let val = to;
      if (/zone|information/.test(val.path)) {
        this.asideList = zoneGuide;
        if (val.path == '/zone/list' || val.path == '/zone/detail') {
          this.activeIndex = '0';
        } else {
          this.activeIndex = '1';
        }
      } else if (/accountManagement/.test(val.path)) {
        this.asideList = accountManagementGuide;
        if (val.path == '/accountManagement/subAccountManagement') {
          this.activeIndex = '0';
        } else if (val.path == '/accountManagement/mainAccountManagement') {
          this.activeIndex = '2';
        } else {
          this.activeIndex = '1';
        }
      } else if (/digtal-storage/.test(val.path)) {
        this.asideList = digtalStorageGuide;
        if (val.path == '/v3/digtal-storage/digtal-storage-list') {
          this.activeIndex = '0';
        }
      } else {
        this.asideList = this.userGuideArr;
        if (val.path == '/edit/index') {
          this.activeIndex = '0';
        } else if (val.path == '/accept/index') {
          this.activeIndex = '1';
        } else if (val.path == '/v3/task-progress/list') {
          this.activeIndex = '2';
        }
      }
      console.log(this.asideList);
    }
  },
  created() {
    this.getStorage = getStorage('userAuthData');
    let val = this.$route;
    if (/zone|information/.test(val.path)) {
      this.asideList = zoneGuide;
      if (val.path == '/zone/list' || val.path == '/zone/detail') {
        this.activeIndex = '0';
      } else {
        this.activeIndex = '1';
      }
    } else if (/accountManagement/.test(val.path)) {
      this.asideList = accountManagementGuide;
      if (val.path == '/accountManagement/subAccountManagement') {
        this.activeIndex = '0';
      } else if (val.path == '/accountManagement/mainAccountManagement') {
        this.activeIndex = '2';
      } else {
        this.activeIndex = '1';
      }
    } else if (/digtal-storage/.test(val.path)) {
      this.asideList = digtalStorageGuide;
      if (val.path == '/v3/digtal-storage/digtal-storage-list') {
        this.activeIndex = '0';
      }
    } else {
      this.asideList = this.userGuideArr;
      if (val.path == '/edit/index') {
        this.activeIndex = '0';
      } else if (val.path == '/accept/index') {
        this.activeIndex = '1';
      } else {
        this.activeIndex = '3';
      }
    }
    // console.log(this.isCollapse)
    // this.CHANGEASIDEACTIVE(this.$route.path) // 初始化 对应aside
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.logo {
  /* height: 3.75em; */
  /* background-color: #027cfa; */
  text-align: center;
  /* line-height: 3.75em; */
  color: #fff;
  /* font-size: 2.5em; */
}

/*aside 激活背景色*/

.aside-left {
  background: #fff;
}
.aside-left .el-menu-item.is-active {
  background: #e4f1ff !important;
  position: relative;
}

.aside-left .el-menu-item.is-active:before {
  content: '';
  width: 4px;
  height: 30px;
  background: #027cfa;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}

.el-menu-vertical-demo * {
  font-size: 1em;
  font-weight: 400;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 10.4vw;
  min-height: 400px;
  min-width: 160px;
  border-right: none !important;
}

.el-menu-item span {
  padding-left: 3px;
}

.el-submenu__title {
  padding-left: 0 !important;
}

.el-submenu__title span {
  padding-left: 3px;
}

.el-submenu .el-menu-item {
  min-width: auto !important;
}
</style>
